import * as React from "react";
import "./Settings.scss";
import { ISettingsStrings } from "./ISettingsStrings";
import { Dropdown, IDropdownOption, IToggleProps, Toggle  } from '@fluentui/react';
// import { Dropdown, IDropdownOption } from '@fluentui/react';
// -- Fabric UI

// const options: IDropdownOption[] = [
//   { key: 'en', text: 'English' },
//   { key: 'de', text: 'German' },
// ];

export interface ISettingsToggle {
  toggleProps: IToggleProps;
  title: string;
}

interface IProps {
  tooltipStatusChange?: any;
  darkMode?: any;
  tooltipsStatus?: any;
  strings?: ISettingsStrings;
  additionalToggles?: ISettingsToggle[];
  languageOptions?: IDropdownOption[];
  defaultSelectedLanguage?: string;
  onChangeLanguage?: (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => void;
}
export class Settings extends React.PureComponent<IProps, {}> {
  constructor(props: IProps) {
    super(props);
  }

  public render(): JSX.Element {
    return (
      <div>
        <div className="settings__wrapper">
          <div className="settings__switch">
            <Toggle
              defaultChecked={this.props.tooltipsStatus}
              onChange={this.props.tooltipStatusChange}
            />
            <div className="bolded">
              {(this.props.strings &&
                this.props.strings.allwaysShowTooltipsToggleLabel) ||
                "Always show tooltips"}
            </div>
          </div>
          <div className="settings__switch">
            <Toggle
              defaultChecked={this.darkModeStatusFromLocalStorage()}
              onChange={(
                _event: React.MouseEvent<HTMLElement>,
                _checked?: boolean
              ) => {
                localStorage.setItem("darkMode", `${_checked}`);
                this.props.darkMode && this.props.darkMode(_checked);
              }}
            />
            <div className="bolded">
              {(this.props.strings && this.props.strings.darkModeToggleLabel) ||
                "Dark mode"}
            </div>
          </div>
          {this.props.additionalToggles && this.props.additionalToggles.map((toggle: ISettingsToggle, index: number) => (
            <div className="settings__switch" key={index}>
              <Toggle {...toggle.toggleProps} />
              <div className="bolded">
                {toggle.title}
              </div>
            </div>
          ))}

          {this.props.languageOptions && (
            <Dropdown
              label={(this.props.strings && this.props.strings.selectLanguageLabel) || "Select language"}
              defaultSelectedKey={this.props.defaultSelectedLanguage}
              options={this.props.languageOptions}
              onChange={this.props.onChangeLanguage}
            />
          )}
        </div>
      </div>
    );
  }

  darkModeStatusFromLocalStorage = () => {
    if (localStorage.getItem("darkMode") === null) {
      return false;
    } else if (localStorage.getItem("darkMode") === "true") {
      return true;
    } else if (localStorage.getItem("darkMode") === "false") {
      return false;
    } else {
      return false;
    }
  };
}
